import { MediaCoreBase } from "./media.core.base"


export class MediaCore extends MediaCoreBase {

}